import { Box, Typography } from '@mui/material';
import React from 'react';
import { motion } from 'framer-motion';
import { SX_STYLES } from '../../styles/components/listItems/ListHospitalsStyle';
import LazyImage from '../general/LazyImage';

const ListHospitals = (props) => {
    return (
        <Box
            component={motion.div}
            whileHover={{ x: 6 }}
            transition={{ type: 'spring', stiffness: 300, damping: 22 }}
            sx={SX_STYLES.container}
        >
            <Box sx={SX_STYLES.imageContainer}>
                <LazyImage src={props.image} sx={SX_STYLES.imageStyle}/>
            </Box>
            <Box sx={SX_STYLES.sectionContainer}>
                <Typography sx={SX_STYLES.date}>{props.date}</Typography>
                <Typography sx={SX_STYLES.hospital}>{props.hospital}</Typography>
                <Typography sx={SX_STYLES.hospitalDescription}>{props.description}</Typography>
            </Box>
        </Box>
    );
}

export default ListHospitals;